import React from "react";
import BannerForm from "../Layout/BannerForm";
import { BannerFormValues } from "src/models/Banner.model";
import { object, string, mixed, array } from "yup";
import { Form, Formik, FormikHelpers } from "formik";
import { Dialog } from "@mui/material";
import { useAddCMSMutation } from "src/services/CMSService";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const AddBannerFormWrapper = ({ onClose }: Props) => {
  const [addBanner] = useAddCMSMutation();
  const initialValues: BannerFormValues = {
    content: [
      {
        name: "",
        image: "",
      },
    ],
  };

  const validationSchema = object().shape({
    content: array().of(
      object().shape({
        name: string().required("Please enter name"),
        image: mixed().required("Please upload image"),
      })
    ),
  });

  const handleSubmit = (
    values: BannerFormValues,
    { setSubmitting, resetForm }: FormikHelpers<BannerFormValues>
  ) => {
    const payload = {
      type: "BANNER",
      content: values.content.map((c) => ({
        name: c.name,
        image: c.image,
      })),
    };

    addBanner(payload)
      .unwrap()
      .then((res) => {
        showToast("success", res?.data?.message);
        onClose();
        // refetch()
        setSubmitting(false);
        resetForm();
      })
      .catch((err) => {
        console.error("Failed to update Contact Info: ", err);
        showToast(
          "error",
          err?.data?.message ||
            "Failed to update Contact Info. Please try again."
        );
        setSubmitting(false);
      });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <BannerForm
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddBannerFormWrapper;
